exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.b-close[data-v-fea6f254]{\n    opacity: .5;\n    cursor: pointer;\n}\n.b-close[data-v-fea6f254]:hover{\n    opacity: 1 !important;\n}\n\n", ""]);

// exports
